import Swiper from "swiper";
export default function _gallery() {
  const swiperElement = ".gallery";
  const thumbnails = [...document.querySelectorAll("figure[data-thumbnail]")];
  const swiperOptions = {
    effect: "fade",
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      reverseDirection: false
    },
    navigation: {
      nextEl: ".gallery_thumbnail--next",
      prevEl: ".gallery_thumbnail--prev"
    },
    pagination: {
      el: ".gallery_thumbnail--list",
      type: "bullets",
      bulletActiveClass: "is-active",
      clickable: true,
      renderBullet: function(index, className) {
        return `
              <li class="gallery_thumbnail--item ${className}">
                <figure class="gallery_thumbnail--img" style="background-image: url('${thumbnails[index].dataset.thumbnail}');"></figure>
              </li>
            `;
      }
    }
  };
  if (document.querySelector(swiperElement)) {
    const gallery = new Swiper(swiperElement, swiperOptions);
    gallery.on("slideChange", function() {
      const showSlideNumber = 3;
      const currentSlideNumber = this.previousIndex;
      const currentIndex = this.activeIndex;
      const galleryLength = this.slides.length;
      const thumbnailSlides = [
        ...document.querySelectorAll(".gallery_thumbnail--item")
      ];
      const thumbnailWidth = thumbnailSlides[0].clientWidth;

      function moveShowSlides($rate) {
        thumbnailSlides.forEach(
          x => (x.style.transform = `translateX(-${$rate}px)`)
        );
      }

      if (currentSlideNumber < currentIndex) {
        if (currentIndex + showSlideNumber <= galleryLength) {
          moveShowSlides(currentIndex * thumbnailWidth);
        } else {
          moveShowSlides((galleryLength - showSlideNumber) * thumbnailWidth);
        }
      } else if (currentSlideNumber > currentIndex) {
        if (galleryLength - showSlideNumber === currentIndex) {
          moveShowSlides((currentIndex - 1) * thumbnailWidth);
        } else if (galleryLength - showSlideNumber > currentIndex) {
          moveShowSlides((currentIndex - 1) * thumbnailWidth);
        }
      }
    });
  }
}
